import React, {useCallback, useState, Fragment, useEffect} from 'react';
import {Button, ButtonToolbar} from 'reactstrap';
import ThemeModal from "../../../../shared/components/ThemeModal";
import {useNavigate} from "react-router-dom";
import paths from "../../../../config/paths";
import {useAddGroupMutation} from "../../../../mutations/groups/AddGroup";
import {toast} from "react-hot-toast";
import PropTypes from "prop-types";


const AddGroupModal = ({companyId}) => {
  const [showModal, setShowModal] = useState(false);
  const [groupName, setGroupName] = useState('');
  const toggleModal = useCallback(() => {setShowModal(!showModal)}, [setShowModal, showModal]);
  const mutation = useAddGroupMutation();
  const nav = useNavigate();
  const addGroup = () => {
    toggleModal();
    mutation.mutate({name: groupName, companyId: companyId});
  }


  useEffect(() => {
    if (!mutation.isIdle) {
      if (mutation.isLoading) {
        toast('Creating the group', {icon: '⏳', duration: Infinity});
      } else {
        toast.dismiss();
        if (mutation.isSuccess) {
          nav(`${paths.configurationGroupsPath}/${mutation.data.id}`);
        } else if (mutation.isError) {
          toast('Error during the creation of the group',{icon: '❌'});
          mutation.reset();
        }
      }
    }
  }, [mutation.isIdle, mutation.isError, mutation.isLoading, mutation.isSuccess, nav, mutation])


  return (
    <Fragment>
      <Button className={"rounded float-right"} size="sm" outline onClick={toggleModal}>Add group</Button>
      <ThemeModal
        isOpen={showModal}
        toggle={toggleModal}
        modalClassName={'ltr-support'}
        className={'modal-dialog--header modal-dialog--dark'}
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggleModal} />
          <h4 className="text-modal  modal__title">Add group</h4>
        </div>

        <div className="modal__body">
          <form className="form form--vertical" onSubmit={addGroup}>
            <div className="form__form-group">
              <span className="form__form-group-label">Insert the group name</span>
              <div className="form__form-group-field">
                <div className="form__form-group-input-wrap">
                  <input name={'groupName'} onChange={(e) => {
                    e.preventDefault();
                    setGroupName(e.target.value);
                  }} />
                </div>
              </div>
            </div>
          </form>
        </div>

        <ButtonToolbar className="modal__footer">
          <Button outline className="rounded" color='success' onClick={addGroup}>Add</Button>
          <Button outline className="rounded" onClick={toggleModal}>Cancel</Button>
        </ButtonToolbar>

      </ThemeModal>
    </Fragment>
  );
};


AddGroupModal.propTypes = {
  companyId: PropTypes.string.isRequired
}

export default AddGroupModal;
